import { render, staticRenderFns } from "./CreateAccountModal.vue?vue&type=template&id=b770da12"
import script from "./CreateAccountModal.vue?vue&type=script&lang=js"
export * from "./CreateAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports